<template>
  <div class="device-container container-with-titleBar">
    <TitleBar
      :show-all-pois="false"
      @poiChangeCallback="poiChangeCallback"
    >
      <div
        class="status-picker"
        @click="showStatusPicker"
      >
        {{ statusText }}
      </div>
    </TitleBar>
    <template v-if="count">
      <div class="device-list">
        <div class="device-title">
          机柜详情
        </div>
        <div class="device-overview">
          <div class="left">
            <div
              class="amount"
              v-text="count"
            ></div>
            <div class="description">
              合作机柜
            </div>
          </div>
          <div class="right">
            <div
              class="amount"
              v-text="onlineCount"
            ></div>
            <div class="description">
              在线机柜
            </div>
          </div>
        </div>
        <ul class="device-item-list border1px-top">
          <li
            v-for="(cabin, index) in showDevices"
            :key="index"
            class="device-item border1px-bottom"
          >
            <div class="top">
              <span class="description">机柜ID：{{ cabin.cabinId }}</span>
              <span
                :class="{ 'offline': cabin.networkStatus === 0 }"
                class="status"
              >{{ ['离线', '在线'][cabin.networkStatus] }}</span>
            </div>
            <div class="bottom">
              <span class="left">充电宝数量：{{ cabin.batteryCount }}个</span>
              <span
                v-if="isShowEmpty(cabin)"
                class="tip"
              >{{ cabin.shortPositionDate | emptyTimeString }}</span>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <NoData
      v-else
      tips="没有找到相关记录"
    />
    <van-popup
      v-model="statusPickerFlag"
      round
      position="bottom"
    >
      <van-picker
        title="筛选机柜状态"
        show-toolbar
        :columns="statusArr"
        :visible-item-count="3"
        @confirm="handlePickUp"
        @cancel="statusPickerFlag = false"
      />
    </van-popup>
    <div class="bottom-btns">
      <a href="tel:4000005658">
        <van-button
          :data-bid="$BID.DEVICE_CALL"
          type="primary"
          color="#1a1a1a"
          round
          style="width:100%"
        >
          联系客服
        </van-button>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Picker from 'vant/lib/picker';
import TitleBar from '@/components/TitleBar';
import NoData from '@/components/NoData';
import Device from '@/api/device';
import STATUS from '@/constants/status';
import 'vant/lib/picker/style';

export default {
  name: 'Device',
  components: {
    TitleBar,
    NoData,
    [Picker.name]: Picker,
  },
  filters: {
    /**
     * 返回 Z分钟 || Y小时Z分钟 || X天Y小时
     * @param time 空仓的时间点，毫秒
     */
    emptyTimeString(time) {
      time = +new Date() - time;
      const minutes = Math.floor(time / 60000);
      const hours = Math.floor(minutes / 60);
      const day = Math.floor(hours / 24);
      let res = '';
      if (day) {
        res = `${day}天`;
      }
      if (hours % 24) {
        res += `${hours % 24}小时`;
      }
      return res ? `机柜已连续空仓${res}` : '';
    },
  },
  data() {
    return {
      status: 2, // 0: 离线, 1: 在线, 2: 全部
      statusArr: ['全部', '在线', '离线'], // 机柜状态数组
      statusPickerFlag: false, // 是否显示机柜状态选择器
      cabinInfos: [], // 设备信息数组
      count: 0, // 机柜总数
      onlineCount: 0, // 在线机柜数
    };
  },
  computed: {
    ...mapState(['currentPoi']),
    // 状态文案
    statusText() {
      return ['离线', '在线', '全部'][this.status];
    },
    // 显示的充电宝列表 根据status不同显示'全部', '在线', '离线'
    showDevices() {
      if (this.status === 2) {
        return this.cabinInfos;
      }
      return this.cabinInfos.filter((item) => item.networkStatus === this.status);
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    async getData() {
      this.$store.commit('setLoading', true);
      await Device.getDeviceStatus(this.currentPoi.poiId).then((res) => {
        if (res.respCode === STATUS.SUCCESS && res.data) {
          this.cabinInfos = res.data.cabinInfos;
          this.count = res.data.count;
          this.onlineCount = res.data.onlineCount;
        } else {
          this.count = 0;
        }
      }).catch(() => {
        this.count = 0;
      });
      this.$store.commit('setLoading', false);
    },
    /**
     * 是否显示空仓文案，空仓时间是否超过12小时
     * @param cabin
     * @returns {*|boolean}
     */
    isShowEmpty(cabin) {
      return cabin.shortPositionDate && (+new Date() - cabin.shortPositionDate) / 3600000 >= 12;
    },
    poiChangeCallback() {
      this.getData();
    },
    showStatusPicker() {
      this.statusPickerFlag = true;
    },
    handlePickUp(value) {
      this.statusPickerFlag = false;
      this.status = ['离线', '在线', '全部'].indexOf(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/mixin';
@include borderCreator("border1px-top", "top", solid, rgba(0, 0, 0, .06));
@include borderCreator("border1px-bottom", "bottom", solid, rgba(0, 0, 0, .06));
.device-container {
  padding: 0 0 170px;
  text-align: left;
  letter-spacing: 0;
  .status-picker {
    position: relative;
    padding-right: 32px;
    color: rgba(0, 0, 0, .84);
    font-size: 26px;
    &::after {
      content: '';
      position: absolute;
      display: block;
      top: 50%;
      right: 0;
      width: 26px;
      height: 26px;
      margin-top: -13px;
      background: url(~@/assets/img/drop-down.png) no-repeat center center;
      background-size: 26px;
    }
  }
  .device-list {
    margin: 18px;
    border-radius: 12px;
    background: #FFF;
    .device-title {
      padding: 30px 36px 18px;
      font-size: 32px;
      font-weight: bold;
      color: rgba(0, 0, 0, .84);
    }
    .device-overview {
      display: flex;
      padding: 0 36px 31px;
      .left {
        width: 216px;
      }
      .right {
        flex: 1;
      }
      .amount {
        position: relative;
        height: 82px;
        line-height: 82px;
        padding-right: 30px;
        font-size: 60px;
        font-weight: bold;
        &::after {
          content: '个';
          position: relative;
          bottom: 5px;
          line-height: 30px;
          padding-left: 12px;
          color: #000;
          font-size: 30px;
        }
      }
      .description {
        color: rgba(0, 0, 0, .6);
      }
    }
    .device-item-list {
      padding: 0 36px;
    }
    .device-item {
      padding: 30px 0;
      &:last-child {
        :after {
          display: none;
        }
      }
      .top {
        display: flex;
        font-size: 30px;
        color: rgba(0, 0, 0, .84);
        .description {
          flex: 1;
        }
        .status {
          font-weight: bold;
          &.offline {
            color: rgba(0, 0, 0, .42);
          }
        }
      }
      .bottom {
        display: flex;
        height: 33px;
        line-height: 33px;
        margin-top: 6px;
        font-size: 24px;
        color: rgba(0, 0, 0, .6);
        .left {
          width: 40%;
        }
        .tip {
          flex: 1;
          color: #DD3429;
          text-align: right;
        }
      }
    }
  }
  .bottom-btns {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 36px;
    background: #FFF;
    .call-btn {
      display: block;
      flex: 1;
    }
  }
}
</style>
